<template>
	<main>
        <div class="bg-grey" style="min-height: 100vh;">
            <header>
                <div class="container text-center">
                    <Logo outerClass="pt-2 pb-0 py-lg-3" color="_dark" innerClass="logo" type="png" />
                </div>
            </header>
            <section id="wizard" class="bg-grey py-3 py-lg-5 home-page">
                <div class="container">
                    <h1 class="uc grad-text text-center mb-3 mb-lg-4" id="home-title">The Funds You Want Fast</h1>
                    <h2 class="hero uc mb-3 mb-lg-4 text-center">Loans from $100 - $5,000 are only moments away</h2>
                    <WizardStep1 />
                </div>
            </section>
        </div>

        <HowItWorks />
        
		<WhyChoose />

        <FooterCTA />

		<Footer />

		<Disclaimers />    

	</main>
</template>

<script>
// @ is an alias to /src
import WizardStep1 from '@/views/wizard/WizardStep1.vue';
import WhyChoose from '@/components/home/WhyChoose.vue';
import HowItWorks from '@/components/home/HowItWorks.vue';
import FooterCTA from '@/components/home/FooterCTA.vue';
import Footer from '@/components/Footer.vue';
import Disclaimers from '@/components/home/Disclaimers.vue';
import Logo from '@/components/Logo.vue';

import { mapActions } from "vuex";

export default {
  name: 'home',
  title: 'Wazki - As Heard on the Radio',
  components: {
    WizardStep1,
	WhyChoose,
	HowItWorks,
	FooterCTA,
	Footer,
    Disclaimers,
    Logo
  },
  methods: {
    ...mapActions(["saveSplitTestData"]),

  },
  created(){
      this.saveSplitTestData({
        "frontendType": "v2",
        "longFormType": "chatbot"
      });
  }
}
</script>

